<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
@import "./reset.scss";
</style>
